import Axios from "API/Axios";
import { AxiosMethodEnum } from "API/Axios";
import { Axios_Route } from "API/AxiosRouts";
import React, { FormEvent, useEffect, useState } from "react";
import { notify, ToastType } from "utils/Toast";
import { ValidationErrorMessages } from "utils/Error";
import { emailCheck } from "utils/rejex";

interface Props {
  Component: any;
}

export interface ErrorAboutUs {
  address: string | null;
  description: string | null;
  email: string | null;
  fax: string | null;
  phone: string | null;
}

const AboutUs: React.FC<Props> = ({ Component }) => {
  const [data, setData] = useState<any>([]);
  const [gotData, setGotData] = useState<boolean>(false);
  const [address, setAddress] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [fax, setFax] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [showErrors, setShowErrors] = useState<boolean>(false);
  const [allowToAdd, setAllowToAdd] = useState<boolean>(true);
  const [error, setError] = useState<ErrorAboutUs>({
    address: null,
    description: null,
    email: null,
    fax: null,
    phone: null,
  });

  useEffect(() => {
    Axios(AxiosMethodEnum.get, Axios_Route.ABOUT_US).then(
      ({ response, success }) => {
        if (success) {
          setData(response);
          setPhone(response[0].phone)
          setEmail(response[0].email)
          setFax(response[0].fax)
          setAddress(response[0].address)
          setDescription(response[0].description)
          setGotData(true);
        }
      }
    );
  }, []);

  useEffect(() => {
    if (showErrors) {
      errorHandling();
    }
  }, [address, description, email, fax, phone]);

  const errorHandling = () => {
    let AllowToContinue = true;

    if (address.length === 0) {
      error.address = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.address = null;
    }

    if (description.length === 0) {
      error.description = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.description = null;
    }

    if (!emailCheck(email)) {
      error.email = ValidationErrorMessages.ERRORS.EMAIL_FORMAT_NOT_VALID;
      AllowToContinue = false;
    } else {
      error.email = null;
    }

    if (fax.length === 0) {
      error.fax = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.fax = null;
    }

    if (phone.length === 0) {
      error.phone = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.phone = null;
    }

    setError({ ...error });

    return AllowToContinue;
  };

  const editAboutUsHandler = (e: FormEvent) => {
    e.preventDefault();

    setShowErrors(true);
    let AllowToContinue = errorHandling();

    if (!AllowToContinue) {
      window.scrollTo({ top: 0 });
      notify(
        Object.values(error).find((index) => index !== null),
        ToastType.error
      );
    }

    if (AllowToContinue && allowToAdd) {
      setAllowToAdd(false);
      const AboutUsObj = {
        id: 1,
        address: address,
        description: description,
        email: email,
        fax: fax,
        phone: phone,
      };
      Axios(AxiosMethodEnum.post, Axios_Route.ABOUT_US_EDIT, AboutUsObj).then(
        ({ response, success }) => {
          setAllowToAdd(true);
          if (success) {
            notify(
              ValidationErrorMessages.SUCCESS.ABOUT_US_EDITED_SUCCESSFULLY,
              ToastType.success
            );
          } else if (!success) {
            notify(response.message, ToastType.error);
          }
        }
      );
    }
  };

  return (
    <div>
      <Component
        gotData={gotData}
        editAboutUsHandler={editAboutUsHandler}
        address={address}
        setAddress={setAddress}
        description={description}
        setDescription={setDescription}
        email={email}
        setEmail={setEmail}
        fax={fax}
        setFax={setFax}
        phone={phone}
        setPhone={setPhone}
        error={error}
      />
    </div>
  );
};

export default AboutUs;
